module.exports = __webpack_public_path__ + "assets/img/advs-skeleton.a358e2f2.png";